
import { defineComponent } from 'vue'
import { iInputColumn } from '../../../../FunctionsCatalog'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import functionsCatalogDatasetFormColumnsTableDescriptor from './FunctionsCatalogDatasetFormColumnsTableDescriptor.json'

export default defineComponent({
    name: 'function-catalog-dateset-form-columns-table',
    components: { Column, DataTable, Dropdown },
    props: { columns: { type: Array }, datasetColumns: { type: Array } },
    data() {
        return {
            functionsCatalogDatasetFormColumnsTableDescriptor,
            inputColumns: [] as iInputColumn[]
        }
    },
    watch: {
        columns() {
            this.loadInputColumns()
        }
    },
    created() {
        this.loadInputColumns()
    },
    methods: {
        loadInputColumns() {
            this.inputColumns = this.columns as iInputColumn[]
        },
        getIconClass(type: string) {
            switch (type) {
                case 'NUMBER':
                    return 'fa fa-hashtag'
                case 'STRING':
                    return 'fa fa-quote-right'
                case 'DATE':
                    return 'fa fa-calendar'
                default:
                    return ''
            }
        },
        onCellEditComplete(event: any) {
            this.inputColumns[event.index] = event.newData
        }
    }
})
